import React from 'react';
import TalenteesLogo from '../image/Talentees-02.png';
import { useI18n } from '../i18n';

export const CareersPage: React.FC = () => {
  const { t } = useI18n();
  const c = t.careers;

  return (
    <div className="min-h-screen bg-black flex flex-col">
      <header className="px-8 py-6">
        <a href="/">
          <img src={TalenteesLogo} alt="Talentees" className="h-8" />
        </a>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center px-6 text-center">
        <p className="text-[#28e675] text-sm font-medium tracking-widest uppercase mb-4">
          {c.label}
        </p>
        <h1 className="text-white font-display text-4xl sm:text-5xl leading-tight mb-6">
          {c.title}<br />
          <span className="text-white/35">{c.titleMuted}</span>
        </h1>
        <p className="text-white/45 text-base max-w-md leading-relaxed mb-10">
          {c.description}
        </p>
        <a
          href="mailto:hello@talentees.net"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium text-black bg-[#28e675] hover:bg-[#34f581] transition-colors"
        >
          {c.cta}
        </a>
      </main>

      <footer className="px-8 py-6 text-center">
        <a href="/" className="text-white/30 hover:text-white/60 text-sm transition-colors">
          {c.backHome}
        </a>
      </footer>
    </div>
  );
};
